import { ReactNode } from "react";
import { StackProps, TypographyProps, Stack, Typography } from "@mui/material";

export interface CardHeaderProps {
    title: ReactNode;
}

function CardHeader(props: CardHeaderProps) {
    const stackProps: StackProps = {
        sx: {
            height: 40,
            paddingX: 2,
            paddingY: 1.5,
            justifyContent: "center",
            backgroundColor: "#EDF0F3",
        },
    };

    const titleProps: TypographyProps = {
        sx: {
            fontSize: 15,
            lineHeight: 1,
            color: "black",
            fontWeight: 600,
        },
        children: props.title,
    };

    return (
        <Stack {...stackProps}>
            <Typography {...titleProps} />
        </Stack>
    );
}

export default CardHeader;
